// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type { NodeJSReadableStream } from "./interfaces-browser.mjs";
